<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box-name">
      <div class="select-label">{{appName}}</div>
    </div>
    <!-- <div class="select-box input_left">
      <Input v-model="searchVer" style="width:150px;" placeholder="请输入版本号"/>
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn" style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear">重置</Button>
    </div> -->
    <div class="option-wrap">
      <Row>
        <Col>
          <!-- <Button type="primary" @click="newAlert"><Icon type="md-add" size="15" /> 上传SDK插件版本</Button> -->
        </Col>
      </Row>
    </div>
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    <Modal
      width="600"
      :mask-closable="false"
      v-model="newdata"
      :footer-hide="editFlag === 'true'?true:false"
      :title="editId ?editFlag === 'true' ? '查看':'编辑':'上传插件新版本'"
      :loading="loading"
      @on-cancel="closeModal"
      @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="apkInfo" :rules="ruleValidate" :label-width="120">
        <FormItem label="版本名称" prop="pluginVerName">
          <Input v-model="apkInfo.pluginVerName" :disabled="true" placeholder="版本名称" />
        </FormItem>
        <FormItem label="版本号" prop="pluginVerCode">
          <Input v-model="apkInfo.pluginVerCode" :disabled="true" placeholder="必须数字" />
        </FormItem>
        <FormItem label="版本状态" prop="enableStatus">
          <RadioGroup v-model="apkInfo.enableStatus">
            <Radio :disabled="editFlag === 'true'" label="启用"></Radio>
            <Radio :disabled="editFlag === 'true'" label="禁用"></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="占用大小" prop="useSpace">
            <Input v-model="apkInfo.useSpace" :disabled="editFlag === 'true'" placeholder="插件解压后的大小，单位MB，如不填写默认100MB" />
            <!-- <p style="color:#c00;">插件解压后的大小，检测磁盘空间是否满足，如不填写默认100M！</p> -->
          </FormItem>
        <!-- <FormItem label="宿主版本" prop="storeVerCodes">
          <Input v-model="apkInfo.storeVerCodes" :disabled="editFlag === 'true'" placeholder="不填写默认全部版本,填写则指定该版本,多个版本可英文逗号隔开" />
          <p>*宿主版本不填写，默认为全部*</p>
        </FormItem> -->
         <!-- <FormItem label="文件上传" prop="apkPath">
          <Upload type="file" accept='.zip,.apk' ref="upload" :before-upload="brforeUpload" :onProgress="fileProgress" :onSuccess="filesuccess" :action="baseUrl + '/extscreenapi/plugin/hili/card/uploadFile'">
              <Button icon="ios-cloud-upload-outline">上传</Button>
          </Upload>
          <div style="font-size:12px;">文件格式为zip/apk</div>
        </FormItem> -->
        <FormItem label="校验值" prop="md5">
          <Input v-model="apkInfo.md5" :disabled="true" placeholder="上传插件后自动生成" />
        </FormItem>
        <FormItem label="更新说明" prop="remarks">
          <Input v-model="apkInfo.remarks" :disabled="editFlag === 'true'" placeholder="备注最大字数为50字" maxlength="50" type="textarea" :rows="4" />
        </FormItem>
      </Form>
    </Modal>
    <verify-modal ref="verify"></verify-modal>
    <gray-modal ref="gray" @close="grayModalClose"></gray-modal>
    <gray-table-modal ref="grayTable"></gray-table-modal>
  </div>
</template>

<script>
import grayModal from '@/components/global/grayModal'
import grayTableModal from '@/components/global/grayTableModal'
import breadcrumb from '@/components/global/breadcrumb'
import verifyModal from '@/components/global/verifyModal'
import https from '../../https'
export default {
  name: 'version',
  data () {
    return {
      loading: true,
      tableLoading: true,
      newdata: false,
      authorized: false,
      pluginId: '',
      appName: '',
      apksList: [],
      searchVer: '',
      sdkVerList: [],
      search: {
        name: ''
      },
      formValidate: {
        remark: '',
        fileName: '',
        files: '',
        refresh: '关闭'
      },
      apkInfo: {
        enableStatus: '启用',
        apkPath: '',
        md5: '',
        pluginId: '',
        remark: '',
        sdkVersion: ''
      },
      ruleValidate: {
        // pluginVerName: {required: true, message: '插件版本名称'},
        apkPath: {required: true, message: '文件格式为zip/apk'}
        // pluginVerCode: {required: true, message: '必须数字'},
        // enableStatus: {required: true, message: '不填写默认全部版本,填写则指定该版本,多个版本可英文逗号隔开'}
        // versionCode: { required: true, pattern: /^(\d+\.\d{0,2}|\d+)$/, message: '请输入版本号，需两段，以一个小数点分割。例：1.01' }
        // sdkVersion: { required: false, pattern: /^\d+(\.\d{1,4}){0,2}$/, message: '请输入sdk最小版本号，需三段，以两个小数点分割。例：1.0.1701' }
      },
      dataSource: [], // table数据源
      columns: [ // table表格
        {
          title: 'ID',
          key: 'id',
          minWidth: 200
        },
        {
          title: '版本名称',
          key: 'pluginVerName',
          minWidth: 240,
          render: (h, params) => {
            let status = ''
            let html = []
            switch (params.row.isInPluginMac) {
              case 0:
                status = params.row.pluginVerName
                html = [
                  h('span', status)
                ]
                break
              case 1:
                status = params.row.pluginVerName
                html = [
                  h('Button', {
                    props: {
                      type: 'success',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }, '指定mac'),
                  h('span', status)
                ]
                break
            }
            return html
          }
        },
        {
          title: '版本号',
          key: 'pluginVerCode',
          minWidth: 100
        },
        {
          title: '审核状态',
          key: 'status',
          minWidth: 100,
          render: (h, params) => {
            let status = ''
            switch (params.row.status) {
              case 0:
                status = '待审核'
                break
              case 1:
                status = '审核通过'
                break
              case 2:
                status = '审核驳回'
                break
              case 3:
                status = '未提审'
                break
            }
            let html = [
              h('span', {
                style: {
                  cursor: 'pointer',
                  color: params.row.status === 3 ? 'black' : 'blue'
                },
                on: {
                  click: () => {
                    if (params.row.status !== 3) {
                      this.$refs.verify.show(params.row, 'sdk', 'sdkVer')
                    }
                  }
                }
              }, status)
            ]
            return html
          }
        },
        {
          title: '启用状态',
          key: 'enableStatus',
          minWidth: 100,
          render: (h, params) => {
            let status = ''
            switch (params.row.enableStatus) {
              case 0:
                status = '禁用'
                break
              case 1:
                status = '启用'
                break
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        // {
        //   title: '宿主版本',
        //   key: 'storeVerCodes',
        //   minWidth: 200,
        //   render: (h, params) => {
        //     let status = ''
        //     if (params.row.storeVerCodes.length > 0) {
        //       status = params.row.storeVerCodes
        //     } else {
        //       status = '全部'
        //     }
        //     let html = [
        //       h('span', status)
        //     ]
        //     return html
        //   }
        // },
        {
          title: '版本状态',
          key: 'versionStatus',
          minWidth: 100,
          render: (h, params) => {
            let status = ''
            switch (params.row.versionStatus) {
              case 0:
                status = '预览状态'
                break
              case 1:
                status = '线上版本'
                break
              case 2:
                status = '历史版本'
                break
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        {
          title: '校验值',
          key: 'md5',
          minWidth: 200
        },
        {
          title: '更新说明',
          key: 'remarks',
          minWidth: 100
        },
        {
          title: '驳回原因',
          key: 'reason',
          minWidth: 100
        },
        {
          title: '灰度投放',
          key: 'grayConfStr',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let aduit_stats = params.row.grayConfStr
            let html = [
              h('span', {
                style: {
                  cursor: 'pointer',
                  color: params.row.aduit_stats === 0 ? 'black' : 'blue'
                },
                on: {
                  click: () => {
                    if (params.row.aduit_stats !== 0) {
                      this.$refs.grayTable.show(params.row.id)
                    }
                  }
                }
              }, aduit_stats)
            ]
            return html
          }
        },
        {
          title: '上传时间',
          key: 'createTime',
          minWidth: 200
        },
        {
          title: '更新时间',
          key: 'updateTime',
          minWidth: 200,
          render: (h, params) => {
            let status = ''
            if (params.row.updateTime != null) {
              status = params.row.updateTime
            } else {
              status = params.row.createTime
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        {
          title: '操作',
          width: 320,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let btn = []
            if (params.row.status === 1) {
              if (params.row.versionStatus === 0) {
                btn = [
                  h('Button', {
                    props: {
                      type: 'success',
                      size: 'small',
                      disabled: (params.row.createBy !== this.userId)
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        https.request({
                          method: 'post',
                          url: '/extscreenapi/plugin/hili/esAppPluginApk/publish',
                          params: {
                            id: params.row.id
                          }
                        }).then(res => {
                          this.$Message.success('发布成功')
                          this.loadData()
                        }).catch(error => {
                          this.$Message.error(error)
                        })
                      }
                    }
                  }, '发布')
                ]
              } else if (params.row.versionStatus === 2) {
                btn = [
                  h('Button', {
                    props: {
                      type: 'success',
                      size: 'small',
                      disabled: (params.row.createBy !== this.userId)
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '版本回退后不可再次回退',
                          content: '可回到上一个已发布的线上版本，且不可再次回退。',
                          onOk: () => {
                            https.request({
                              method: 'post',
                              url: '/extscreenapi/plugin/hili/esAppPluginApk/rollback',
                              params: {
                                id: params.row.id
                              }
                            }).then(res => {
                              this.$Message.success('撤回版本成功')
                              this.loadData()
                            }).catch(error => {
                              this.$Message.error(error)
                            })
                          }
                        })
                      }
                    }
                  }, '版本回退')
                ]
              } else {
                btn = [
                  h('span', '')
                ]
              }
            } else if (params.row.status === 2 || params.row.status === 3) {
              btn = [
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small',
                    disabled: (params.row.createBy !== this.userId)
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      if (this.pStatus === '0' || this.pStatus === '2') {
                        this.$Message.error('插件还未通过审核')
                        return
                      }
                      https.request({
                        method: 'put',
                        url: 'extscreenapi/plugin/hili/esAppPluginApk/edit',
                        data: { ...params.row, status: 0 }
                      }).then(res => {
                        this.$Message.success('提交成功')
                        this.loadData()
                      })
                    }
                  }
                }, '提交审核')
              ]
            } else {
              btn = []
            }
            btn.unshift(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: (params.row.status === 0)
                },
                style: {
                  width: '50px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.newAlert(params.row)
                  }
                }
              }, params.row.createBy === this.userId ? '编辑' : '查看')
              // }, '编辑')
            )
            btn.push(h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                disabled: (params.row.createBy !== this.userId) || params.row.versionStatus === 1
              },
              on: {
                click: () => {
                  this.$refs.gray.show(params.row.id, 'sdk')
                }
              }
            }, '灰度投放'),
            h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                disabled: (this.uid !== this.userId ? this.uid === 1 : false) || params.row.status === 1
              },
              style: {
                width: '50px',
                marginLeft: '10px'
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: `删除提示`,
                    content: `确定删除【${params.row.pluginVerCode}】吗？`,
                    onOk: () => {
                      https.request({
                        method: 'DELETE',
                        url: 'extscreenapi/plugin/hili/esAppPluginApk/delete?id=' + params.row.id
                      }).then(res => {
                        console.log(res)
                        if (res.code === 400) {
                          this.$Message.error(res.data.message)
                          return
                        }
                        this.$Message.success('删除成功')
                        this.loadData()
                      }).catch(error => {
                        this.$Message.error(error)
                      })
                    }
                  })
                }
              }
            }, '删除'))
            return h('div', btn)
          }
        }
      ],
      editFlag: 'false',
      baseUrl: '',
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1, // 当前页
      imgUrl: '',
      userId: '',
      pStatus: '0'
    }
  },
  components: {
    grayTableModal,
    grayModal,
    breadcrumb,
    verifyModal
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.userId = localStorage.getItem('userId')
    this.baseUrl = process.env.API_HOST
    this.pluginId = this.$route.query.id
    this.pStatus = this.$route.query.status
    this.appName = this.$route.query.pluginTitle
    this.apkInfo.pluginId = this.$route.query.id
    this.loadData()
  },
  methods: {
    grayModalClose () {
      this.loadData()
    },
    getVerList () {
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/extPublic/getDictItems?dicCode=runtime_sdk_version'
      }).then(res => {
        console.log(res)
        this.sdkVerList = res.result
      })
    },
    brforeUpload () {
      let main = this.$refs.upload
      if (main.fileList && main.fileList.length) {
        main.fileList.forEach(item => {
          main.clearFiles()
        })
      }
    },
    fileProgress () {
      this.apkInfo.apkPath = ''
      this.apkInfo.md5 = ''
    },
    filesuccess (e) {
      this.apkInfo.apkPath = e.result.filePath
      this.apkInfo.md5 = e.result.fileMd5
    },
    changeAuditState (val) {
      if (val) {
        this.loadData(val)
      }
    },
    clearAuditState () {
      this.loadData()
    },
    // 加载tabs列表
    loadData (state = 0) {
      // pluginVerCode
      let params = {
        column: 'pluginVerCode',
        order: 'desc',
        pageSize: this.pageSize,
        pageNo: this.current,
        pluginId: this.pluginId,
        // versionCode: this.searchVer,
        query: state
      }
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/esAppPluginApk/list',
        params: params
      }).then(res => {
        console.log(res.result.records)
        this.tableLoading = false
        this.dataList = res.result.records
        this.total = res.result.total
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.searchVer = ''
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    newAlert (row = {}) {
      this.getVerList()
      if (Object.keys(row).length > 1) {
        this.apkInfo = {
          pluginVerName: row.pluginVerName,
          pluginVerCode: row.pluginVerCode,
          useSpace: row.useSpace ? row.useSpace / 1024 / 1024 : '',
          storeVerCodes: row.storeVerCodes,
          enableStatus: row.enableStatus === 0 ? '禁用' : '启用',
          apkPath: row.apkPath,
          md5: row.md5,
          remarks: row.remarks,
          pluginId: row.pluginId
        }
        this.editId = row.id
        this.editFlag = row.createBy === this.userId ? 'false' : 'true'
      } else {
        this.apkInfo = {
          pluginVerName: '',
          pluginVerCode: '',
          useSpace: '',
          storeVerCodes: '',
          enableStatus: '启用',
          apkPath: '',
          md5: '',
          remarks: '',
          pluginId: this.$route.query.id
        }
        this.editId = ''
        this.editFlag = 'false'
      }
      this.newdata = true
    },
    delItem (id) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p class="del-modal-txt">确定要删除吗？</p>',
        onOk: () => {
          https.request({
            method: 'DELETE',
            url: 'extscreenapi/plugin/hili/card/delete?id=' + id,
            data: {id: id}
          }).then(res => {
            this.$Message.success('删除成功')
            this.loadData()
          })
        }
      })
    },
    closeModal () {
      this.$refs['formValidate'].resetFields()
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          console.log(this.apkInfo.md5)
          if (this.apkInfo.md5.length === 0) {
            this.$Message.success('请上传插件包')
            this.changeLoading()
            return
          }
          setTimeout(() => {
            this.changeLoading()
            console.log(this.apkInfo)
            this.apkInfo.enableStatus = this.apkInfo.enableStatus === '启用' ? 1 : 0
            this.apkInfo.useSpace = this.apkInfo.useSpace === '' || this.apkInfo.useSpace === null ? '104857600' : this.apkInfo.useSpace * 1024 * 1024
            if (this.editId.length > 0) {
              https.request({
                method: 'put',
                url: 'extscreenapi/plugin/hili/esAppPluginApk/edit',
                data: {...this.apkInfo, id: this.editId}
              }).then(res => {
                if (res.code === 500) {
                  this.$Message.error(res.message)
                  this.closeModal()
                  this.newdata = false
                  this.editId = ''
                  this.loadData()
                  return
                }
                this.$Message.success('编辑成功')
                this.closeModal()
                this.newdata = false
                this.editId = ''
                this.loadData()
              })
            } else {
              https.request({
                method: 'post',
                url: 'extscreenapi/plugin/hili/esAppPluginApk/add',
                data: this.apkInfo
              }).then(res => {
                if (res.code === 500) {
                  this.$Message.error(res.message)
                  return
                }
                this.$Message.success('上传成功')
                this.$refs.upload.clearFiles()
                this.closeModal()
                this.newdata = false
                this.editId = ''
                this.loadData()
              }).catch(error => {
                this.$Message.error(error)
              })
            }
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .code-box {
    display: inline-block;
    border: 1px solid #dcdee2;
    padding: 15px;
    text-align: center;
    line-height: 1;
  }
  .code-box p {
    margin-top: 15px;
  }
  .code-box img {
    width:200px;
    height:200px;
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    left: 260px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
      font-weight: bold;
      font-size:20px;
    }
  }
  .select-box-name{
    display: flex;
    position: absolute;
    top: 20px;
    right:28px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
      font-weight: bold;
      font-size:20px;
    }
  }
  .select_icon_url{
    width: 30px;
    height: 30px;
    border: 1px solid #ccc;
    border-radius: 10px;
  }
  .input_left_three{
    left:430px;
  }
</style>



// WEBPACK FOOTER //
// src/components/esSdk/versionSdk.vue